import * as React from 'react'
import { observer } from 'mobx-react'
import ArchiveItemViewModel from './ArchiveItemViewModel'
import { useBrandingSettings } from 'hooks/branding'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from 'components/ModalSheet'
import Button from 'components/Button'
import styles from './ArchiveItemModal.sass'

interface Props {
  vm: ArchiveItemViewModel
}

export default observer(function ArchiveItemDialog({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()
  const workspaceName = vm.inventoryItem?.workspace?.name
  const inventoryItemName = vm.inventoryItem?.name
  const inventoryItemNameLength = inventoryItemName?.length ?? 0
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton dataTest="inventory-items-close-archive-modal" />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_archive-item.svg')}
              alt="Archive item"
            />
          )}
          <h3 className={styles.title}>
            {vm.inventoryItem?.override ? (
              <>
                You are about to archive this override of{' '}
                {inventoryItemNameLength < 44 ? (
                  <span className={styles.inventoryItemName}>
                    {inventoryItemName}
                  </span>
                ) : (
                  inventoryItemName
                )}
              </>
            ) : (
              <>
                You are about to archive{' '}
                {inventoryItemNameLength < 44 ? (
                  <span className={styles.inventoryItemName}>
                    {inventoryItemName}
                  </span>
                ) : (
                  inventoryItemName
                )}
              </>
            )}
          </h3>
          <p className={styles.description}>
            {vm.inventoryItem?.override ? (
              'All legends in ' +
              (workspaceName !== undefined ? workspaceName : 'this workspace') +
              ' will need to be updated to reference the global version of this item.'
            ) : (
              <>
                All legends will no longer be able to reference this service
                item. All existing legends that used this item, will need manual
                adjustments.
              </>
            )}
          </p>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            disabled={vm.archive.pending}
            onClick={vm.close}
            type="default"
          >
            Cancel
          </Button>
          <Button
            onClick={vm.archive}
            loading={vm.archive.pending}
            disabled={vm.archive.pending}
            type="danger"
            dataTest="inventory-items-archive-button"
          >
            Archive
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
